<template>
  <div class="image-add">
    <!-- <a @click.stop target="blank" :href="getItem.uploadedFile">{{ $t('displayImgBtnTitle') }}</a> -->
    <div class="uploaded-images" v-viewer="viewerProps" @click.stop>
      <img :src="uploadedFile">
    </div>
  </div>
</template>

<script>
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import Vue from 'vue'
Vue.use(Viewer)

export default {
  name: 'ImageViewer',
  props: [
    'uploadedFile'
  ],
  data () {
    return {
      viewerProps: {
        button: true,
        navbar: false,
        title: false,
        toolbar: false,
        tooltip: false,
        movable: true,
        zoomable: true,
        rotatable: true,
        scalable: false,
        transition: true,
        fullscreen: true,
        keyboard: false
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Fb/ImageViewer.vue